import { watch, onUnmounted } from "vue";
import { toValue } from "@vueuse/core";
import { c as createTrapStackController } from "./focusTrap-DmkaYJTC.mjs";
function useTrapStackControl(shouldPause, options = {}) {
  const trapStackController = createTrapStackController();
  watch(shouldPause, () => {
    if (toValue(options.disabled)) {
      return;
    }
    if (toValue(shouldPause)) {
      trapStackController.pause();
    } else {
      trapStackController.unpause();
    }
  });
  onUnmounted(() => {
    trapStackController.unpause();
  });
}
export {
  useTrapStackControl as u
};
//# sourceMappingURL=useTrapStackControl-b3A_383w.mjs.map
